import { MarkdownReact } from "@/components/MarkdownReact";

interface JournalEntryProps {
  content: string;
}

/**
 * Renders the markdown body of a single Agent Pulse journal entry
 * with monospace "old-school memo" styling.
 * @param props - The journal entry content to display
 * @returns A formatted journal entry body
 */
export function JournalEntry({ content }: JournalEntryProps) {
  return (
    <div className="prose prose-sm max-w-none font-mono text-foreground/90 dark:prose-invert prose-headings:font-semibold prose-headings:tracking-tight prose-headings:text-[15px] prose-headings:mt-6 prose-headings:mb-2 first:prose-headings:mt-0 prose-h3:text-[13.5px] prose-p:text-[13px] prose-p:leading-[1.72] prose-li:text-[13px] prose-li:leading-7 prose-strong:text-foreground">
      <MarkdownReact>{content}</MarkdownReact>
    </div>
  );
}
